var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"page-title"},[_vm._v("Edit event")]),(_vm.event)?_c('EventForm',{attrs:{"event":_vm.event}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }